import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import http from "@/plugins/request";
import { applySiteMeta } from "@/utils/siteMeta";

Vue.use(Vuex);

let fetchSchoolConfigPromise = null;

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => {
    return {
      user: state.user,
      userBak: state.userBak,
      sysConfig: state.sysConfig,
      courseOrder: state.courseOrder,
      logoTitle: state.logoTitle,
      config: state.config,
      studyCourse: state.studyCourse,
      showLoading: state.showLoading,
      loading: state.loading,
      tenantInfo: state.tenantInfo,
      token: state.token,
      examConfig: state.examConfig,
      examId: state.examId,
      schoolInfo: state.schoolInfo,
    };
  },
});

export default new Vuex.Store({
  state: {
    user: {},
    userBak: [],
    sysConfig: {},
    courseOrder: {},
    logoTitle: {
      imgUrl: "https://adult-study-test.whxunw.com/img/XunwLogo.f9a93328.png",
      name: process.env.VUE_APP_BASE_TITLE,
    },
    config: {},
    studyCourse: {},
    showLoading: false,
    loading: true,
    tenantInfo: {},
    token: "",
    examConfig: [],
    examId: "",
    schoolInfo: {}
  },
  mutations: {
    LOGIN(state, user) {
      state.user = user;
      // state.examConfig = user.examConfig || [];
      // state.examId = (user.examConfig || []).find((e) => e.status).id;
    },
    LOGINBAK(state, user) {
      state.userBak = user;
    },
    SYSCONFIG(state, data) {
      state.sysConfig = data;
    },
    LOGOUT(state) {
      state.sysConfig = null;
      state.user = null;
      state.menus = [];
      state.token = "";
    },
    SET_COURSE(state, studyCourse) {
      state.studyCourse = studyCourse;
    },
    SET_REGINFO(state, regInfo) {
      state.user.regInfo = regInfo;
    },
    UNSET_COURSE(state) {
      state.studyCourse = null;
    },
    PHONE(state, user) {
      state.user = { ...state.user, ...user };
    },
    CREATE_COURSE_ORDER(state, courseOrder) {
      state.courseOrder = courseOrder;
    },
    DESTROY_COURSE_ORDER(state) {
      state.courseOrder = {};
    },
    setLogoTitle(state, logoTitle) {
      state.logoTitle = logoTitle;
    },
    setConfig(state, config) {
      // console.log(config);
      Object.keys(config).map((item) => {
        if (config[item]) {
          state.config[item] = config[item];
        }
      });
    },
    SET_SHOW_LOADING(state, showLoading) {
      state.showLoading = showLoading;
    },
    SET_TENANT_INFO(state, info) {
      if (info && typeof info === "object") {
        state.tenantInfo = info;
      }
    },
    SET_TOKEN(state, token) {
      window.sessionStorage.setItem("token", token);
      state.token = token;
    },
    SET_SCHOOLINFO(state, schoolInfo) {
      state.schoolInfo = schoolInfo;
    },
  },
  actions: {
    fetchSchoolConfig({ commit }) {
      if (!fetchSchoolConfigPromise) {
        fetchSchoolConfigPromise = http
          .get_s("/student/pc/schoolConfig")
          .then((res) => {
            if (res && typeof res === "object") {
              commit("SET_TENANT_INFO", res);
              applySiteMeta(res);
            }
            return res;
          })
          .catch((err) => {
            fetchSchoolConfigPromise = null;
            return Promise.reject(err);
          });
      }
      return fetchSchoolConfigPromise;
    },
  },
  modules: {},
  plugins: [vuexLocal.plugin],
});
